function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.681 0.672257C20.2254 0.240544 19.6223 0 18.9954 0C18.3685 0 17.7654 0.240544 17.3099 0.672257L5.42511 11.9314C5.06121 12.2765 4.77145 12.6926 4.57359 13.1539C4.37572 13.6153 4.27392 14.1123 4.27442 14.6146V28.3134C4.27507 29.2914 4.66309 30.2291 5.3532 30.9204C6.04331 31.6117 6.97903 32 7.95466 32H11.6349C12.611 32 13.5471 31.6113 14.2372 30.9195C14.9274 30.2277 15.3152 29.2893 15.3152 28.3109V22.1624C15.3152 21.8363 15.4444 21.5235 15.6745 21.2929C15.9045 21.0623 16.2166 20.9327 16.5419 20.9327H21.4489C21.7743 20.9327 22.0863 21.0623 22.3164 21.2929C22.5464 21.5235 22.6757 21.8363 22.6757 22.1624V28.3109C22.6757 29.2893 23.0634 30.2277 23.7536 30.9195C24.4438 31.6113 25.3798 32 26.3559 32H30.0362C31.0122 32 31.9483 31.6113 32.6385 30.9195C33.3287 30.2277 33.7164 29.2893 33.7164 28.3109V14.6121C33.7162 14.1101 33.6139 13.6135 33.4156 13.1525C33.2173 12.6916 32.9273 12.276 32.5633 11.9314L20.681 0.667338V0.672257Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0.274414,
  y: 0,
  width: 37.442,
  height: 40,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5975addc.svg";
export { ForwardRef as ReactComponent };